<template>
  <section class="content">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="col-md-5 col-sm-12 col-xs-12">
        <div class="form-group col-md-12 col-sm-12 col-xs-12">
          <label>Tên sản phẩm</label>
          <input type="text" class="form-control" v-model="filterData.name"
                 placeholder="Nhập tên công ty ..."/>
        </div>
      </div>
      <div class="col-md-2 col-sm-12 col-xs-12">
        <div class="d-flex justify-content-between align-items-center">
          <b-button variant="warning" @click="filter" style="margin-top: 26px">
            <span class="glyphicon glyphicon-search" aria-hidden="true"></span>Tìm kiếm
          </b-button>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items"
                    show-empty>
          <template #table-busy>
            <div class="text-center my-2 mt-5 mb-5">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Đang tải...</strong>
            </div>
          </template>
          <template #empty="scope">
            <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
          </template>
          <template v-slot:cell(id)="data">
            {{ genSeqId(data) }}
          </template>
          <template v-slot:cell(actions)="dataId">
            <b-button
              variant="success"
              style="min-width: 35px"
              v-b-tooltip.hover
              title="Thêm vào danh sách sử dụng gói"
              :disabled="dataId.item.use_package"
              @click="addCompanyPackage(dataId.item.id)"
            ><i
              :class="dataId.item.use_package? 'fa fa-check' : 'fa fa-plus'"/></b-button>
          </template>

        </b-table>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center justify-content-between">
        <div class="page-size-container">
          <span>Hiển thị</span>
          <b-form-select
            id="pageSize"
            v-model="pageSize"
            :options="pageSizes"
            required
          ></b-form-select>
          <span>  dòng</span>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRow"
          :per-page="pageSize"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import Multiselect from '../lib/vue-multiple-select/Multiselect'
import {mapGetters} from 'vuex'
import Utils from '../common/utils'
import CompanyAPI from '../api/company'
import PackageAPI from '../api/package'
import {find} from 'lodash'

export default {
  name: 'CompanyTable',
  components: {
    'va-box': VABox,
    Multiselect
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ])
  },
  props: {},
  data () {
    return {
      filterData: {
        name: ''
      },
      items: [],
      fields: [
        {
          key: 'id',
          label: 'STT',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'name',
          label: 'Tên công ty',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'owner',
          label: 'Chủ công ty',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'phone',
          label: 'SĐT',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'type',
          label: 'Ngành hàng',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 10%',
          class: 'actions-cell',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      debounceCompany: null,
    }
  },
  mounted () {
    this.filter()
  },
  methods: {
    genSeqId (data) {
      return data.index + (this.currentPage - 1) * this.pageSize + 1
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true

      CompanyAPI.filter(this.filterData, this.currentPage - 1, this.pageSize).then(res => {
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      }).finally(() => {
        this.loading = false
      })
    },
    async addCompanyPackage (id) {
      const item = find(this.items, {id})
      if (!item) return
      this.loading = true
      const defaultPackage = JSON.stringify([{
        startAt: '',
        unitPrice: 0
      }])
      try {
        await PackageAPI.create({
          company_id: id,
          viettel: defaultPackage,
          vinaphone: defaultPackage,
          mobifone: defaultPackage,
          other: defaultPackage
        })
        item.use_package = true
      } catch (e) {
        Utils.handleError(this.$bvToast, e)
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CompanyTable.vue